var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarTemp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 190 190",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 189.75,
    height: 189.75,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard11",
    x: 0,
    y: 0,
    width: 189.75,
    height: 189.75
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 119.25,
    width: 39.894,
    height: 70.5,
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,124.258l40.712,0l-1.425,17.705c-21.659,7.161 -37.673,-11.263 -39.287,-17.705Z",
    style: {
      fill: "#c8c6c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.875,30.75c18.627,0 33.75,27.52 33.75,55.875c0,28.355 -15.123,46.875 -33.75,46.875c-18.627,0 -33.75,-18.52 -33.75,-46.875c0,-28.355 15.123,-55.875 33.75,-55.875Z",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.75,33c-6.628,-27.33 -88.383,-18.126 -78.75,38.25c1.122,6.564 3.071,14.902 2.963,23.625c-0.124,9.944 -2.213,18.375 -2.213,18.375l9.75,-6.75c0.788,5.124 0.137,8.712 -1.5,11.25c7.735,3.013 23.153,6.508 23.153,6.508c-6.124,-7.65 -13.912,-23.193 -10.026,-37.112c3.834,-13.733 39.423,-14.335 54.853,-38.67c0,0 2.29,4.404 4.595,11.446c4.878,14.907 9.821,41.635 -6.761,63.438c0,0 12.635,-3.221 18.936,-5.61c2.437,-3.708 4.098,-8.096 5.097,-13.063c1.225,-6.087 1.456,-13.044 0.903,-20.687l7.5,6.75c-0.123,-33.398 -11.779,-57.588 -28.5,-57.75Z",
    style: {
      fill: "#104e21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,130.5c-4.903,2.75 -8.862,6.933 -11.25,13.5c-35.495,7.862 -53.88,19.292 -57.75,33.75l0,12l177.75,0l0,-11.25c-6.882,-18.955 -29.802,-27.998 -58.125,-34.5c-0.976,-6.329 -6.981,-12.487 -10.731,-13.5c-0.875,39.831 -13.269,57 -20.019,57c-6.75,0 -19.742,-16.294 -19.875,-57Z",
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,124.258l40.712,0",
    style: {
      fill: "none"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarTemp);
export default __webpack_public_path__ + "static/media/avatar-temp.1a70ed7495842e8ab2baf0c42c21825d.svg";
export { ForwardRef as ReactComponent };